import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Select from 'react-select';

import * as generalApi from '@api/generalApi';

class GenericTypesInput extends Component {
  constructor(props) {
    super(props);
    this.state = { typeOptions: [], subTypeOptions: [], typeChildren: {} };
  }

  componentDidMount() {
    const { types, entity, value } = this.props;
    const typeOptions = [];
    const typeChildren = {};
    let parentType = null;

    types
      ?.filter((type) => type.targetEntityType.includes(entity))
      ?.map((type) => {
        if (type.childOf) {
          if (type.label in typeChildren) {
            const children = typeChildren[type];
            children.push(type);
            typeChildren[type.childOf.label] = children;
          } else {
            typeChildren[type.childOf.label] = [type];
          }
        } else {
          typeOptions.push(type);
          if (value && type.value === value) {
            parentType = type.label;
          }
        }
      });

    this.setState({
      typeOptions: typeOptions,
      typeChildren: typeChildren,
      subTypeOptions: parentType ? typeChildren[parentType] : [],
    });
  }

  render() {
    const { t, onChange, placeholder, value, isMulti, subTypeValue, subTypeOnChange } = this.props;
    const { typeOptions, typeChildren, subTypeOptions } = this.state;

    return (
      <>
        {typeOptions && (
          <Select
            isMulti={isMulti}
            value={
              isMulti
                ? typeOptions.filter((option) => value && value.includes(option.value))
                : typeOptions.find((option) => option.value === value)
            }
            noOptionsMessage={() => t('noOptions')}
            options={typeOptions}
            onChange={(newType) => {
              generalApi.mappingToJson({ mapping: newType.defaultValues }).then((response) => {
                onChange?.(newType, response.value);
                this.setState({
                  subTypeOptions: typeChildren[newType.label],
                });
              });
            }}
            placeholder={placeholder}
          />
        )}
        {subTypeOptions && (
          <div className="input-group">
            <Select
              isMulti={isMulti}
              value={
                isMulti
                  ? subTypeOptions.filter(
                      (option) => subTypeValue && subTypeValue.includes(option.value)
                    )
                  : subTypeOptions.find((option) => option.value === subTypeValue)
              }
              noOptionsMessage={() => t('noOptions')}
              options={subTypeOptions}
              onChange={(newType) => {
                generalApi.mappingToJson({ mapping: newType.defaultValues }).then((response) => {
                  subTypeOnChange?.(newType, response.value);
                });
              }}
              placeholder={t('form.label.equipmentSubType')}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    types: state.platform.types,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(withTranslation('translation')(GenericTypesInput));
